import { Button, Image } from "@atoms";
import { ImageUploader } from "@molecules";
import { useState } from "react";
import { useUser } from "@auth";
import { AuthSection } from "@organisms";
import { useTranslation } from "react-i18next";

export interface UploadLogoTemplateProps {
  onContinue: () => void;
}

export const UploadLogoTemplate = ({
  onContinue,
}: UploadLogoTemplateProps): JSX.Element => {
  const partner = useUser();
  const [logo, setLogo] = useState<string>(partner?.images?.logoUrl || "");
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex">
      <AuthSection />
      {/* Right side - Image uploader and buttons */}
      <div className="w-full lg:w-1/2 min-h-screen flex items-center justify-center bg-white">
        <div className="w-full max-w-md px-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {t("onboardingUploadLogo.title")}
          </h1>
          <p className="text-gray-600 text-md mb-8">
            {t("onboardingUploadLogo.subtitleLine1")}<br />{t("onboardingUploadLogo.subtitleLine2")}
          </p>
          <section className="mb-8 w-full">
            <ImageUploader onLogoChange={setLogo} />
          </section>
          <div className="flex flex-col gap-4">
          <Button
              variant="primary"
              label={t("onboardingUploadLogo.next")}
              color="brand-orange"
              hoverColor="primary-dark"
              textColor={logo ? "white" : "neutral-darkest"}
              onClick={onContinue}
              size="lg"
              disabled={!logo}
              stretch
            />
            <Button
              variant="link"
              label={t("onboardingUploadLogo.skip")}
              onClick={onContinue}
            />
          </div>
        </div>
      </div>
    </div>
  );
}; 
